export default __webpack_public_path__ + "c339010.mp3";